function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_19",
  "data-name": "Group 19",
  transform: "translate(5.567 5.579)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_54",
  "data-name": "Path 54",
  d: "M207.272,8.383c-3.757,0-7.479-.571-11.157-.231a120.623,120.623,0,0,0-107.9,100.772L67.362,237.374C55.452,310.741,112.09,377.317,186.418,377.317h20.854l20.854-.744a119.483,119.483,0,0,0,118.312-139.2L325.584,108.925A119.2,119.2,0,0,0,207.272,8.383Z",
  transform: "translate(-65.775 -7.639)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_55",
  "data-name": "Path 55",
  d: "M392.073,237.235,371.218,108.786A120.614,120.614,0,0,0,252.163,7.5q-5.636,0-11.157.514A120.623,120.623,0,0,1,348.9,108.785l20.854,128.449C381.669,310.6,325.031,377.177,250.7,377.177h22.315C347.344,377.178,403.983,310.6,392.073,237.235Z",
  transform: "translate(-110.666 -7.5)",
  fill: "rgba(147,147,147,0.69)"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_20",
  "data-name": "Group 20",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_56",
  "data-name": "Path 56",
  d: "M91.806,110.668a115.043,115.043,0,0,1,71.206-88.541,5.578,5.578,0,1,0-4.11-10.373,126.208,126.208,0,0,0-78.11,97.126L59.938,237.33a125.9,125.9,0,0,0,39.7,113.632,5.579,5.579,0,0,0,7.511-8.25,114.779,114.779,0,0,1-36.2-103.594Z",
  transform: "translate(-58.291 -2.91)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_57",
  "data-name": "Path 57",
  d: "M226.823,12.9A115.052,115.052,0,0,1,360.4,107.758L377.341,212.1a5.58,5.58,0,0,0,5.5,4.685,5.638,5.638,0,0,0,.9-.073,5.579,5.579,0,0,0,4.612-6.4L371.414,105.97A126.27,126.27,0,0,0,224.889,1.913,5.579,5.579,0,0,0,226.823,12.9Z",
  transform: "translate(-99.789 0)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_58",
  "data-name": "Path 58",
  d: "M371.112,313.542a5.579,5.579,0,0,0-11.013,1.788A115.035,115.035,0,0,1,246.551,448.8H204.842a114.809,114.809,0,0,1-58.716-16.062,5.578,5.578,0,0,0-5.707,9.586,125.959,125.959,0,0,0,64.421,17.633H246.55A126.193,126.193,0,0,0,371.112,313.542Z",
  transform: "translate(-78.633 -79.124)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_59",
  "data-name": "Path 59",
  d: "M228.128,285.688a5.579,5.579,0,1,0,5.579-5.579A5.579,5.579,0,0,0,228.128,285.688Z",
  transform: "translate(-101.8 -71.759)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_60",
  "data-name": "Path 60",
  d: "M353.554,363.27a5.579,5.579,0,1,0,5.579-5.579A5.579,5.579,0,0,0,353.554,363.27Z",
  transform: "translate(-133.932 -91.634)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_61",
  "data-name": "Path 61",
  d: "M318.628,211.623a5.579,5.579,0,1,0,5.579-5.579A5.579,5.579,0,0,0,318.628,211.623Z",
  transform: "translate(-124.984 -52.785)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_62",
  "data-name": "Path 62",
  d: "M158.457,388.375a5.579,5.579,0,1,0,5.579-5.579A5.579,5.579,0,0,0,158.457,388.375Z",
  transform: "translate(-83.952 -98.065)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_63",
  "data-name": "Path 63",
  d: "M210.707,164.512a5.579,5.579,0,1,0-5.579-5.579A5.579,5.579,0,0,0,210.707,164.512Z",
  transform: "translate(-95.908 -39.287)",
  fill: "rgba(147,147,147,0.69)"
}));

function SvgPotato(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "potato",
    xmlns: "http://www.w3.org/2000/svg",
    width: 294.119,
    height: 380.835,
    viewBox: "0 0 294.119 380.835",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPotato);
export default __webpack_public_path__ + "static/media/potato.ebf2bc85.svg";
export { ForwardRef as ReactComponent };